import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/seniormaster/actionTypes';
import {  updateTwoDCommission } from '../../redux/actions/seniormaster/updateSeniormaster';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

class Update2DCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.smaster?.id,
            commission:values.twoDCommission
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update TwoD Commission"
                key={this.props.smaster?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-2dc-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-2dc-form"
                    name="basic"
                    initialValues={{
                        twoDCommission:this.props.smaster?.twoDCommission,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="twoDCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.seniorMaster.update2dCommissionVisible,
    loading: state.seniorMaster.loading,
    token: state.auth.token,
    error: state.seniorMaster.error,
    message: state.seniorMaster.message,
    smaster:state.seniorMaster.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj, token) => dispatch(updateTwoDCommission(obj, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_2D_COMMISSION_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Update2DCommissionModal);